import React, { Fragment } from "react";
import { Tabs, Tab, TabContent } from "react-bootstrap";
import AddressView from "./AddressView";
import { connect } from "react-redux";

interface AddressesViewProps
{
    data: Addresses;
    role?: any;
    settings?: any;
}

class AddressesView extends React.Component<AddressesViewProps>
{
    render(): React.ReactNode
    {
        let tabClass = "";

        if (this.props.settings.length > 0)
            tabClass = (this.props.role == "academicAdvisor" && this.props.settings.filter(itm => itm.settingId == "psContactAddress")[0].isActive == true) ? "d-none" : "";

        if (this.props.data.addresses.length == 0)
            return <div className="text-center" id='error'>
                <br />
                <p className="error-text">No Addresses available</p>
            </div>;

        const termAddresses = this.props.data.addresses.filter(itm => itm.addressType == "TR1" || itm.addressType == "TR2");
        const homeAddresses = this.props.data.addresses.filter(itm => itm.addressType == "HO1");
        const tempAddresses = this.props.data.addresses.filter(itm => itm.addressType == "TTR");
        const officeAddresses = this.props.data.addresses.filter(itm => itm.addressType == "OF");

        return <Fragment>
            <Tabs id="tab">
                <Tab eventKey="term" title="Term">
                    <AddressView addressType={"TR1"} data={termAddresses} />
                </Tab>
                <Tab eventKey="temporaryTerm" title="Temporary Term">
                    <AddressView addressType={"TTR"} data={tempAddresses} />
                </Tab>
                <Tab eventKey="home" title="Home" tabClassName={tabClass}>
                    <AddressView addressType={"HO1"} data={homeAddresses} />
                </Tab>
                <Tab eventKey="office" title="Office" tabClassName={tabClass}>
                    <AddressView addressType={"OF"} data={officeAddresses} />
                </Tab>
            </Tabs>
        </Fragment>;
    }
}

const mapStateToProps = (state: any) => ({
    role: state.app.user.role,
    settings: state.app.privacySettings
});

export default connect(mapStateToProps)(AddressesView);